import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
export class HomeComponent {
  constructor(private router: Router) {}

  navigate(card: any) {
    this.router.navigate([card.route]);
  }

  cards = [
    {
      title: 'Market Overview',
      description:
        "Explore dynamic Power BI reports with flexible filters for markets, clubs, and time periods. It's an easy way to stay on top of your KPIs and quickly spot the insights that matter.",
      iconPath: '/assets/images/market_overview.svg',
      route: '/market-overview',
    },
    {
      title: 'Market Fan Exploration',
      description:
        'Use ready-made or custom queries to build data tables, create fan segments, schedule recurring runs, and keep track of your query history, all designed to make your workflow smoother and more organized.',
      iconPath: '/assets/images/market_fan_exploration.svg',
      route: '/market-fan-exploration',
    },
    {
      title: 'Market Insights',
      description:
        'Visualize your results through customizable charts and dashboards that help you track trends, understand fan behavior, and turn data into meaningful, action-ready insights..',
      iconPath: '/assets/images/marketing_insights.svg',
      route: '/market-insights',
    },
    {
      title: 'Marketing Requests',
      description:
        "Send work requests to the Fan Engagement Marketing COE for support with scope,feasibility, and timing. They'll help ensure every project gets off to a strong, well-planned start.",
      iconPath: '/assets/images/marketing_requests.svg',
      route: '/marketing-requests',
    },
  ];
}
